// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export const USE_MOCK_SERVER = window.__ENV__.VITE_USE_MOCK_SERVER || import.meta.env.VITE_USE_MOCK_SERVER;
export const PERSIST_MOCK_SERVER_DATA = window.__ENV__.VITE_PERSIST_MOCK_SERVER_DATA || import.meta.env.VITE_PERSIST_MOCK_SERVER_DATA;
export const API_URL = window.__ENV__.VITE_API_URL || import.meta.env.VITE_API_URL;
export const MSAL_SCOPES = window.__ENV__.VITE_MSAL_SCOPES || import.meta.env.VITE_MSAL_SCOPES;
export const AZURE_CLIENT_ID = window.__ENV__.VITE_AZURE_CLIENT_ID || import.meta.env.VITE_AZURE_CLIENT_ID;
export const AZURE_TENANT_ID = window.__ENV__.VITE_AZURE_TENANT_ID || import.meta.env.VITE_AZURE_TENANT_ID;
export const AZURE_REDIRECT_URI = window.__ENV__.VITE_AZURE_REDIRECT_URI || import.meta.env.VITE_AZURE_REDIRECT_URI;
export const AZURE_ENABLE_LOGGING = window.__ENV__.VITE_AZURE_ENABLE_LOGGING || import.meta.env.VITE_AZURE_ENABLE_LOGGING;
